import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadDesignService } from '@app/feature/store-admin/services/uploadDesign/uploadDesign.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-edit-design',
  templateUrl: './edit-design.component.html',
  styleUrls: ['./edit-design.component.css']
})
export class EditDesignComponent implements OnInit {

  imageSrc !: any;
  editDesignForm: FormGroup;
  isCustomizableDesign !: false;

  constructor(public dialogRef: MatDialogRef<EditDesignComponent>, private formBuilder: FormBuilder,
    private uploadDesignService: UploadDesignService, private notification: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any, private loaderService: LoaderService, private domSanitizer: DomSanitizer,
    private errorhandlerService: ErrorhandlerService) {
    this.editDesignForm = this.formBuilder.group({
      UploadedDesignId : [''],
      UploadedBase64FileUrl : [''],
      DesignName: ['', Validators.compose([Validators.required])],
      DesignDescription: [''],
      DesignPrice: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,8}(\.[0-9]+)?$')])],
      ModifiedBy : [localStorage.getItem('userId')]
    });
   }

  ngOnInit() {
    this.fn_editDesign(this.data.uploadDesignId);
  }

  get f() { return this.editDesignForm.controls; }

  onclose(): void {
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }

  /**Function to update edited design */
  fn_updateDesign(form: FormGroup) {
    this.loaderService.show();
    this.uploadDesignService.updateDesign(form.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notification.success(res.Message, 'Design');
        this.dialogRef.close();
      } else if (res.StatusCode === 500) {
        this.notification.error('An error occured', 'Error');
      }
      this.loaderService.hide();
       }, (err: any) => {
        // this.notification.error('An error occured', 'Error');
        this.errorhandlerService.handleError(err);
        this.loaderService.hide();
    });
  }

  /**Function to get edit design details */
   fn_editDesign(uploadDesignId: number) {
    this.loaderService.show();
      this.uploadDesignService.editDesign(uploadDesignId).subscribe((res: any) => {
          if (res.Data.ResponseData !== null && res.StatusCode === 200) {
            this.isCustomizableDesign = res.Data.ResponseData.IsCustomizable;
            this.editDesignForm.setValue({
              UploadedDesignId: res.Data.ResponseData.UploadedDesignId,
              UploadedBase64FileUrl : res.Data.ResponseData.UploadedBase64FileUrl,
              DesignName: res.Data.ResponseData.DesignName,
              DesignDescription: res.Data.ResponseData.DesignDescription,
              DesignPrice: res.Data.ResponseData.DesignPrice,
              ModifiedBy : localStorage.getItem('userId')
            });
            this.imageSrc = this.domSanitizer.bypassSecurityTrustUrl( res.Data.ResponseData.UploadedBase64FileUrl);
            this.loaderService.hide();
          } else if (res.StatusCode === 400) {
            this.loaderService.hide();
            this.notification.info(res.Message, 'Invalid design');
          }  else if (res.StatusCode === 500) {
            this.loaderService.hide();
            this.notification.error('An error occured', 'Error');
          }
      },
      err => {
          this.loaderService.hide();
          // this.notification.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
      });
   }

  onSelectFile(event: { target: { files: Blob[]; }; }): void {
      const reader = new FileReader();

      if (event.target.files && event.target.files.length) {
        reader.readAsDataURL(event.target.files[0]);

        reader.onload = () => {
          const b = this.editDesignForm.get('UploadedBase64FileUrl');
          if (b) {
            b.patchValue(reader.result);
          }

          // this.editDesignForm.controls['imageInputValidationField'].setValue(event.target.files ?
          //   event.target.files.length : '');
          this.imageSrc = reader.result;
          // this.isShowPreview = false;
        };
      }
    }
}
